<template>
  <div>
    <div class="el-tabs--border-card">
      <div class="user-operation__forget-password">
        <!--<h1 class="user-operation__title">
      <img :src="companyInfo.logo" alt="logo">
      <span>Forget Password</span>
        </h1>-->
        <h1 class="user-operation__title">Reset Your Password</h1>
        <el-form
          label-width="0"
          :model="forgetPasswordFormModel"
          :rules="rules"
          class="user-operation__forget-password-form"
          ref="forgetPasswordForm"
        >
          <el-form-item prop="email" ref="email">
            <el-input
              type="text"
              placeholder="Email"
              v-model="forgetPasswordFormModel.email"
              @change="allowSendingVerifyCode"
            ></el-input>
          </el-form-item>
          <el-form-item class="user-operation__sms-validate-code" prop="SMSVerifyCode">
            <el-input
              placeholder="Authentication code"
              v-model="forgetPasswordFormModel.SMSVerifyCode"
              :readonly="!isAllowSendingVerifyCode"
              :maxlength="6"
            ></el-input>

            <el-button
              type="primary"
              size="mini"
              class="user-operation__sms-button"
              :disabled="SMSVerificationCodeBtn.disabled"
              :loading="isLoadingSMSVerifyCode"
              @click="getSMSVerificationCode"
            >{{SMSVerificationCodeBtn.text}}</el-button>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              placeholder="New password"
              v-model="forgetPasswordFormModel.password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input
              type="password"
              placeholder="Confirm password"
              v-model="forgetPasswordFormModel.confirmPassword"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="buttonSumbit">
          <el-button
            type="primary"
            :loading="isLoading"
            class="user-operation__forget-password-submit"
            @click.enter="submitForm"
          >Confirm</el-button>
        </div>
      </div>
      <br />
      <br />
    </div>
  </div>
</template>
<script>
import api from "../../vuex/api";
import { mapGetters, mapActions } from "vuex";
import * as types from "../../vuex/types";

export default {
  data() {
    const assignValidator = (type, trigger = "blur") =>
      Object.assign(
        {
          required: true,
          trigger
        },
        {
          validator: (rules, value, callback, source, options) => {
            this.$store.dispatch(type, {
              rules,
              value,
              callback,
              source,
              options
            });
          }
        }
      );
    return {
      isLoading: false,
      publicKey: "",
      isAllowSendingVerifyCode: false,
      isLoadingSMSVerifyCode: false,
      isCounting: false,
      SMSVerificationCodeBtn: {
        disabled: true,
        text: "get verification code"
      },
      rules: {
        email: [assignValidator(types.VERIFY_EMAIL)],
        SMSVerifyCode: [
          {
            required: true,
            trigger: "blur",
            message: "Please fill in the received verification code"
          }
        ],
        password: [assignValidator(types.VERIFY_REGISTER_PASSWORD)],
        confirmPassword: [
          {
            required: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (value === "") {
                callback(new Error("please input password again"));
              } else if (value !== this.forgetPasswordFormModel.password) {
                callback(new Error("Two passwords inconsistent"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      forgetPasswordFormModel: {
        email: "",
        SMSVerifyCode: "",
        password: "",
        confirmPassword: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL,
      companyInfo: types.GET_COMPANY_INFO,
      userInfo: types.GET_USER
    })
  },
  methods: {
    ...mapActions({
      forgetPassword: types.FORGET_PASSWORD,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getGenerateRSAPublicKey: types.GET_GENERATE_RSA_PUBLIC_KEY
    }),
    allowSendingVerifyCode(val) {
      if (this.isCounting === false) {
        this.isAllowSendingVerifyCode = val.trim() !== "";
        this.SMSVerificationCodeBtn = {
          disabled: val.trim() === "",
          text: "get verification code"
        };
      }
    },
    getSMSVerificationCode() {
      // REGISTRATION与忘记密码的短信验证倒计时不需要共用，需要就将相关操作扔去action，现在这样就直接请求，降低复杂度
      this.isLoadingSMSVerifyCode = true;
      this.$refs.forgetPasswordForm.validateField("email");
      if (this.$refs.email.validateState !== "error") {
        api
          .getSMSForEmail({
            email: this.forgetPasswordFormModel.email,
            tokenId: this.userInfo.token
          })
          .then(res => {
            const resData = res.data;
            let countDownTime = 420;
            if (Number(resData.code) === 0) {
              const countDown = setInterval(() => {
                this.isLoadingSMSVerifyCode = false;
                countDownTime -= 1;

                if (countDownTime !== 0) {
                  this.SMSVerificationCodeBtn = {
                    disabled: true,
                    text: `Expire in ${countDownTime} seconds`
                  };
                } else {
                  this.SMSVerificationCodeBtn = {
                    disabled: false,
                    text: "get verification code"
                  };
                  clearInterval(countDown);
                  this.isCounting = false;
                }
              }, 1000);
            } else {
              this.isLoadingSMSVerifyCode = false;
              this.setAlertMessage({
                show: true,
                content: resData.result
              });
            }
          })
          .catch(error => {
            if (error) {
              this.isLoadingSMSVerifyCode = false;
            } else {
              this.isLoadingSMSVerifyCode = false;
            }
          });
      } else {
        this.isLoadingSMSVerifyCode = false;
        this.SMSVerificationCodeBtn = {
          disabled: true,
          text: "get verification code"
        };
      }
    },
    submitForm() {
      this.$refs.forgetPasswordForm.validate(valid => {
        if (valid) {
          const form = this.forgetPasswordFormModel;
          this.isLoading = true;
          this.isCounting = true;
          const encrypt = new JSEncrypt();
          encrypt.setPublicKey(this.publicKey);
          const _password = encodeURI(encrypt.encrypt(form.password));
          this.forgetPassword({
            email: form.email,
            validCode: form.SMSVerifyCode,
            password: form.password
          }).then(res => {
            this.isLoading = false;
            if (Number(res.data.code) === 0) {
              this.$router.push("/login");
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.getGenerateRSAPublicKey().then(res => {
      this.publicKey = res.data.publicKey;
    });

        var seo = document.getElementById("seo")
    
    var meta=document.getElementById("seometa");
    if(!meta){
    meta=document.createElement("meta");
    meta.name="description";
    meta.id="seometa";
    document.head.insertBefore(meta,seo);
    }
    
    var keywords=document.getElementById("seokeywords");
    if(!keywords){
    keywords=document.createElement("meta");
    keywords.name="keywords";
    keywords.id="seokeywords"
    document.head.insertBefore(keywords,seo);
    }

    document.title="Forget Password - American Credit"
    meta.content="Forget Password";
    keywords.content="Forget Password, american credit";
  }
};
</script>
<style lang="scss">
.user-operation__forget-password {
  @include userOperationBlockStyle;
  float: none;
  margin: 0 auto;
  margin-top: 70px;
  /*padding:20px 52px 20px;*/
  padding: 0;
  border-radius: 5px;
  overflow: hidden;
  width: 480px;
  box-shadow: 0 0 0.5rem rgba(21, 30, 52, 0.75);
  position: relative;
  z-index: 5;
}

.user-operation__forget-password-form {
  @include userOperationFormStyle;

  .el-radio__label {
    font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
    color: $lighterTrueBlack;
    font-size: 12px;
  }
}

.user-operation__forget-password-form .is-required {
  width: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.buttonSumbit {
  width: 100%;
}

.buttonSumbit .user-operation__forget-password-submit {
  float: none;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  border: none;
  color: #fff;
  margin-top: 40px;
  margin-bottom: 30px;
  color: #fff;
  background-color: #498bd8;
  border-color: #3c83d5;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),
    0 1px 1px rgba(0, 0, 0, 0.075);
}

.buttonSumbit .user-operation__forget-password-submit:hover {
  background-color: #498bd8;
  border: none;
}

.user-operation__sms-validate-code {
  @include resetBFC;
}

.user-operation__sms-button {
  //    @include vertical-center;
  position: absolute;
  top: 4px;
  right: 0;
  border-color: $lighterWaterBlue;
  background: $lighterWaterBlue;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    border-color: $lighterWaterBlue;
    background: $lighterWaterBlue;
  }

  &.is-loading {
    @include vertical-center;
  }
}

.user-operation__forget-password-submit {
  margin-top: 8px;
  border: 1px solid $orange;
  width: 100%;
  height: 45px;
  // line-height: 45px;
  // letter-spacing: 18px;
  font-size: 14px;
  background: $orange;

  &:hover,
  &:focus,
  &:active {
    border: 1px solid $orange;
    background: $orange;
  }

  & span {
    // margin-right: -18px; // letter spacing fix
  }
}
</style>



// WEBPACK FOOTER //
// ForgetPassword.vue?019771d7